<div class="services">
  <div class="safety-flooring"><p><span>Safety Flooring</span></p></div>
  <div class="marmoleum"><p><span>Marmoleum</span></p></div>
  <div class="vinyl"><p><span>Vinyl Flooring</span></p></div>
  <div class="whiterock"><p><span>Wall Cladding</span></p></div>
  <div class="carpet-tiles"><p><span>Carpet Tiles</span></p></div>
  <div class="nosings"><p><span>Nosings</span></p></div>
  <div class="diamond-grinding"><p><span>Diamond Grinding</span></p></div>
</div>